var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 6.66663V11.6666L12.25 14.0833L12.9167 13.0833L9.58334 11.0833V6.66663H8.33334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 10C15.0589 10.8283 15.0035 11.674 14.771 12.4788C14.5384 13.2836 14.1342 14.0285 13.5861 14.6621C13.038 15.2957 12.3591 15.803 11.5962 16.1491C10.8333 16.4951 10.0044 16.6717 9.16666 16.6667C5.91666 16.6667 3.33332 14.0834 3.33332 10.8334C3.33332 7.58337 5.91666 5.00004 9.16666 5.00004C9.74999 5.00004 10.3083 5.08337 10.8333 5.24171V3.52504C10.3 3.40004 9.74166 3.33337 9.16666 3.33337C4.99999 3.33337 1.66666 6.66671 1.66666 10.8334C1.66666 15 4.99999 18.3334 9.16666 18.3334C10.2231 18.3378 11.2684 18.118 12.2336 17.6886C13.1988 17.2592 14.0619 16.63 14.766 15.8424C15.4701 15.0548 15.9991 14.1269 16.3181 13.1198C16.6371 12.1127 16.7389 11.0494 16.6167 10H14.9333V10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 4.16663V1.66663H15V4.16663H12.5V5.83329H15V8.33329H16.6667V5.83329H19.1667V4.16663H16.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon__time.5d38e081d3686e9aae50c46657b3fe2a.svg";
export { ForwardRef as ReactComponent };